import _ from "lodash";

import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { PageBlock } from "components/Page";
import SegmentList from "components/Lists/SegmentList";
import { Link } from "react-router-dom";
import { providers } from "data/actions";
import Chart from "components/Charts/Chart";

class BrandCategoryTargets extends Component {
  static contextTypes = {
    router: PropTypes.object
  };

  componentWillMount() {
    this.props.actions.fetchProviders();
  }

  handleLogoClick = e => {
    this.context.router.history.push("/medier" + this.props.brand.key);
  };

  renderTargetCharts = targets => {
    if (this.props.pending)
    {
      return null;
    }
    return _.map(targets, (t, key) => {
      const provider = this.props.providers[t.providerid];
      if (!provider) {
        return <p key={key}>No targets</p>;
      }
      return (
        <PageBlock
          key={key}
          right={true}
          label={t.name}
          className="brand_provider"
        >
          {provider.logoUrl && (
            <img alt="" src={provider.logoUrl} title={provider.name} />
          )}

          <span>{provider.name}</span>

          <div className="brand_provider__chart">
            <Chart stats={t} />
          </div>
        </PageBlock>
      );
    });
  };

  render = () => (
    <div>
      {this.props.title &&
        this.props.targets && (
          <PageBlock right={true} label={this.props.title} />
        )}
      <div>{this.renderTargetCharts(this.props.targets)}</div>
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    providers: state.providers.list.data,
    pending: state.providers.list.pending
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators({ ...providers }, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch)(BrandCategoryTargets);



// WEBPACK FOOTER //
// ./src/components/Brand/BrandCategoryTargets.jsx